import { customAlphabet } from "nanoid";

const validCharacters = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
export const newID = (length: number) => customAlphabet(validCharacters, length)()